import { Injectable } from '@angular/core';
import { EventManagerAdminService } from './event-manager/event-manager-admin.service';
import { HelperManagerAdminService } from './helper-manager-admin.service';

type VimeoObject = {
  getCurrentTime: () => Promise<number>;
  setCurrentTime: (seconds: number) => Promise<void>;
  play: () => Promise<void>;
  pause: () => Promise<void>;
  setVolume: (volume: number) => Promise<number>;
  setPlaybackRate: (playbackRate: number) => Promise<void>;
  getColors: () => Promise<[]>;
  setColors: (colors: []) => Promise<[]>;
  loadVideo: (id?: number, url?: string, object?: object) => Promise<number | string | object>;

};
@Injectable({
  providedIn: 'root'
})

export class VimeoManagerService {
  public vimeo!: VimeoObject;
  constructor(
    private eventManager: EventManagerAdminService,
    private ragAiHelper: HelperManagerAdminService
  ) {
    this.eventManager.on('RAGAI.VIMEO.playerready', (_event, vimeoObj) => {
      this.vimeo = vimeoObj as VimeoObject;
    });
  }

  public async play() {
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.VIMEO.PLAY', {});
    await this.vimeo.play();
  }

  public async pause() {
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.VIMEO.PAUSE', {});
    await this.vimeo.pause();
  }

  public async currentPlayPosition(): Promise<number> {
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.VIMEO.CURRENTPLAYPOSITION', {});
    return await this.vimeo.getCurrentTime();
  }

  public async seekTo(hours: number, minutes: number, seconds: number) {
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.VIMEO.SEEKTO', { seconds });
    seconds = this.ragAiHelper.timeToSeconds(hours, minutes, seconds);
    await this.vimeo.setCurrentTime(seconds);
  }
  public async setVolume(percentageVolume: number) {
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.VIMEO.SETVOLUME', { percentageVolume });
    const volume = percentageVolume / 100;
    return await this.vimeo.setVolume(volume);
  }
  public async setPlaybackRate(playbackRate: number) {
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.VIMEO.SETPLAYBACKRATE', { playbackRate });
    await this.vimeo.setPlaybackRate(playbackRate);
  }
  public async getColors() {
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.VIMEO.GETCOLORS', {});
    return await this.vimeo.getColors();
  }
  public async setColors(colors: []) {
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.VIMEO.SETCOLORS', { colors });
    return await this.vimeo.setColors(colors);
  }
  public async loadVideo(id?: number, url?: string, object?: object) {
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.VIMEO.LOADVIDEO', { id, url, object });
    return await this.vimeo.loadVideo(id, url, object);
  }
}